import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { ApiProvider } from './lib/api-provider'
import App from './App.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ApiProvider>
      <App />
    </ApiProvider>
  </StrictMode>,
)
